import 'css-chunksrc/client/pages/projectPage/discussionsPage/discussions/styles.scss';export default {
  "discussions": "_discussions_o6384_1",
  "discussion": "_discussion_o6384_1"
};